import '.bx{position:relative;}.ssr-plugin'
import '.i1{width:64px;}.ssr-plugin'
import '.i2{height:64px;}.ssr-plugin'
import '.c3{flex-shrink:0;}.ssr-plugin'
import '.d{position:absolute;}.ssr-plugin'
import '.i3{bottom:-4px;}.ssr-plugin'
import '.cy{right:-4px;}.ssr-plugin'
import '.dj{border-radius:50%;}.ssr-plugin'
import '.i4{border:2px solid var(--shades-white);}.ssr-plugin'
import '.h{overflow:hidden;}.ssr-plugin'
import '.i5{width:32px;}.ssr-plugin'
import '.i6{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="bx i1 i2 c3"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="d i3 cy dj i4 h i5 i6"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
